import axios from "axios";

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";
const om = {
  /**
   * Realizar request genérica a la API
   * @param {Object} payload payload para el endpoint
   */
  request(payload) {
    const body = JSON.parse(JSON.stringify(payload));
    // Siempre retornar la promesa de axios
    return axios.post(`${API_BASE_SRC}/formularioAdquisicion/alta`, body);
  }
};

export default om;
